// The pinned queues of the Chats sidebar group. Each is the same list opened on
// a scope it does not let go of; the list, the thread and every action are the
// unscoped screen's, so the only thing a queue owns is where it starts.
//
// Kept in its own leaf module because the conversation header needs the slugs
// to build its back link, and importing them from conversation.routes.js would
// close a cycle (routes -> ConversationView -> ConversationBox -> header).
// Exported on its own so surfaces that exist only on this queue (the
// attention strip in ChatList) can name it without re-encoding the slug.
export const FOR_YOU_QUEUE_SLUG = 'for-you';

export const UNASSIGNED_QUEUE_SLUG = 'unassigned';

export const CHAT_QUEUES = [
  {
    // "For you": the agent's own conversations. The route name keeps its
    // historical `conversation_mine` identity; only the path and the visible
    // label carry the new name (the old /mine paths redirect here).
    slug: FOR_YOU_QUEUE_SLUG,
    name: 'conversation_mine',
    scope: { assigneeTypeScope: 'me' },
  },
  {
    slug: UNASSIGNED_QUEUE_SLUG,
    name: 'conversation_unassigned',
    scope: { assigneeTypeScope: 'unassigned' },
  },
];
